import Link from "next/link";

import { routes } from "src/shared/routes";
import { useSSTheme } from "src/components/reusable/hooks/useSSTheme";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";
import type { TRegistrationCardData } from "src/shared/types/globalStotre.types";

export const REGISTRATION_CARDS: TRegistrationCardData[] = [
  {
    title: "Your Concert, Your Way - Upgrade Now",
    description: (
      <>
        Choose the upgrades that fit your style—comfort, access, and exclusive
        benefits await.
      </>
    ),
    authRedirectPage: routes.home,
  },
];

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "How come I don't see seat upgrades available for purchase?",
    answer:
      "Upgrades are only eligible for those with a game ticket already. If you do not have a ticket for the game, please go to Rockies Ticket Information | Colorado Rockies to purchase.",
  },
  {
    question: "Will there be seat upgrades available for every game?",
    answer:
      "Upgrades are subject to availability, please check back in on the day of the game to see eligible offers.",
  },
  {
    question: "Where are my tickets?",
    answer:
      "After successful purchase, seat upgrades will be delivered within your Ballpark app. Please note that these tickets are not eligible for entry into Coors Field.",
  },
  {
    question: "Where will my seats be located?",
    answer:
      "Seats will be located in the sections noted in your seat upgrade offer.",
  },
  {
    question: "Can these tickets be transferred to a friend?",
    answer: "Seat upgrades are non transferrable and not eligible for resale.",
  },
  {
    question: "Can these tickets be transferred to a friend?",
    answer: "Seat upgrades are non transferrable and not eligible for resale.",
  },
  {
    question: "Can my seats be changed?",
    answer:
      "Once tickets have been sent to your account, they cannot be changed. Please head to Ticket Resolution for any assistance you may require.",
  },
];

export const TERMS_AND_CONDITION_ADD_ON = () => {
  const theme = useSSTheme();
  return (
    <>
      By purchasing you agree to receive notifications regarding ticket delivery
      and agree to the{" "}
      <Link
        style={{
          cursor: "pointer",
          color: theme.colors.teamPrimary,
          textDecoration: "underline",
          textUnderlineOffset: "0.2em",
          fontWeight: "bold",
        }}
        target="_blank"
        href="https://www.attend.tech/terms-of-use"
      >
        Terms of Use
      </Link>
      ,{" "}
      <Link
        style={{
          cursor: "pointer",
          color: theme.colors.teamPrimary,
          textDecoration: "underline",
          textUnderlineOffset: "0.2em",
          fontWeight: "bold",
        }}
        target="_blank"
        href="https://www.attend.tech/privacy-policy"
      >
        Privacy Policy
      </Link>{" "}
      and the Live Nation Premium Seat Program{" "}
      <Link
        href="https://premium.livenation.com/seat-terms"
        target="_blank"
        style={{
          cursor: "pointer",
          color: theme.colors.teamPrimary,
          textDecoration: "underline",
          textUnderlineOffset: "0.2em",
          fontWeight: "bold",
        }}
      >
        Terms & Conditions
      </Link>
      .
    </>
  );
};
